import Icon from '../../../components/AppIcon';
import { ConsultationBenefit } from '../types';

interface ConsultationBenefitsProps {
  benefits: ConsultationBenefit[];
}

const ConsultationBenefits = ({ benefits }: ConsultationBenefitsProps) => {
  return (
    <section className="py-16 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-brand-primary mb-4">
            What You'll Get From Your Free Audit
          </h2>
          <p className="text-lg text-text-secondary max-w-2xl mx-auto">
            A comprehensive 30-minute consultation that delivers immediate value and actionable insights
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit) => (
            <div
              key={benefit.id}
              className="bg-card border border-border rounded-xl p-6 hover:shadow-lg transition-shadow duration-fast"
            >
              <div className="w-14 h-14 bg-gradient-to-br from-primary to-accent rounded-lg flex items-center justify-center mb-4">
                <Icon name={benefit.icon} size={28} className="text-white" />
              </div>
              
              <h3 className="text-xl font-semibold text-brand-primary mb-3">
                {benefit.title}
              </h3>
              
              <p className="text-text-secondary leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
        
        <div className="mt-12 bg-gradient-to-r from-primary/10 to-accent/10 rounded-2xl p-8 text-center">
          <div className="flex items-center justify-center space-x-2 text-primary mb-4">
            <Icon name="Award" size={24} />
            <span className="text-lg font-semibold">100% Value Guarantee</span>
          </div>
          <p className="text-text-secondary max-w-2xl mx-auto">
            If you don't walk away with at least 3 actionable automation ideas that could save you 10+ hours monthly, we'll send you a $50 Amazon gift card. That's how confident we are in the value of our audits.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ConsultationBenefits;